import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class KitSpecsDetailService extends DatabaseGwService{

  URL_PATH: string = "/kit-spec-details";
}
